module.exports = __webpack_public_path__ + "static/media/dolne-wy-atmo.a4eb0543.svg";